import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.143rem;
`;

export const BlockHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const BlockOverviewHeader = styled.div`
  margin-bottom: 0;
  margin-right: 1rem;
`;

export const BlockHeaderActionGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  row-gap: 10px;
`;

export const SearchModeToggleSlot = styled.div<{ $first?: boolean }>`
  margin-left: ${({ $first }) => ($first ? '0' : '1.5rem')};
`;

export const BlockHeaderChildren = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  width: 100%;
`;
